import { Preview } from "@creatomate/preview";

const syncAspectRatio = (
  handleUpdateData: (newData: Record<string, any>) => void,
  preview: Preview
) => {
  const creatomateJson = preview.getSource();
  const { width, height } = creatomateJson;
  switch (true) {
    case width === 720 && height === 1280:
    case width === 1080 && height === 1920:
      handleUpdateData({ aspectRatioStringValue: "tall-portrait" });
      break;
    case width === 1024 && height === 1280:
    case width === 1512 && height === 1920:
      handleUpdateData({ aspectRatioStringValue: "portrait" });
      break;
    case width === 1280 && height === 1280:
    case width === 1920 && height === 1920:
      handleUpdateData({ aspectRatioStringValue: "square" });
      break;
    case width === 1280 && height === 1024:
    case width === 1920 && height === 1512:
      handleUpdateData({ aspectRatioStringValue: "landscape" });
      break;
    case width === 1280 && height === 720:
    case width === 1920 && height === 1080:
      handleUpdateData({ aspectRatioStringValue: "wide-landscape" });
      break;
    default:
      break;
  }
};

export default syncAspectRatio;
